import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { createRequestOptionAndCriteria } from 'src/app/shared';
import { environment } from 'src/environments/environment.test';

@Injectable()
export class EstablecimientosService {
  private resourceUrl = `${environment.API_URL}/establecimientos`;

  constructor(private http: HttpClient) {}

  listCurrent(req: any = {}): Observable<any> {
    const params = createRequestOptionAndCriteria({}, req);
    return this.http.get(`${this.resourceUrl}/current`, {
      params: params,
      observe: 'response',
    });
  }

  listCurrentCompleto(req: any = {}): Observable<any> {
    const params = createRequestOptionAndCriteria({}, req);
    return this.http.get(`${this.resourceUrl}/current/completo`, {
      params: params,
      observe: 'response',
    });
  }

  saveCompleto(params: any): Observable<any> {
    return this.http.post(`${this.resourceUrl}/completo`, params, {
      observe: 'response',
    });
  }

  editCompleto(id: number, params: any): Observable<any> {
    return this.http.put(`${this.resourceUrl}/completo/${id}`, params, {
      observe: 'response',
    });
  }

  getCompleto(id: number): Observable<any> {
    return this.http.get(`${this.resourceUrl}/completo/${id}`, {
      observe: 'response',
    });
  }

  getMatricesAgencias(): Observable<any> {
    return this.http.get(
      this.resourceUrl +
        '/current/completo?tipo.in=MATRIZ&tipo.in=UNIDAD_NEGOCIO',
      { observe: 'response' },
    );
  }

  getNextNumero(tipo: string, padreId: number): Observable<any> {
    return this.http.get(`${this.resourceUrl}/next-numero/${tipo}/${padreId}`, {
      observe: 'response',
    });
  }

  activar(id: number): Observable<any> {
    return this.http.put(
      `${this.resourceUrl}/activar/${id}`,
      {},
      { observe: 'response' },
    );
  }

  inactivar(id: number): Observable<any> {
    return this.http.put(
      `${this.resourceUrl}/inactivar/${id}`,
      {},
      { observe: 'response' },
    );
  }

  getEstablecimientosPorTipo(): Observable<any> {
    return this.http.get(`${this.resourceUrl}/tipos/completo/current`, {
      observe: 'response',
    });
  }
}
